import parseColor from 'color';
export function encode(color, siteColors) {
    if (color.name) {
        var wixColor = siteColors.find(function (c) { return c.name === color.name; });
        var rgbColor = parseColor(wixColor.value)
            .alpha(color.opacity)
            .rgb()
            .string();
        return {
            opacity: color.opacity,
            rgba: rgbColor,
            color: {
                value: rgbColor,
                name: wixColor.name,
                reference: wixColor.reference,
            },
        };
    }
    var parsedColor = parseColor(color.value);
    return {
        opacity: color.opacity,
        rgba: parsedColor
            .alpha(color.opacity)
            .rgb()
            .string(),
        color: false,
    };
}
export function decode(color, siteColors) {
    var _a;
    if (!color.value) {
        return null;
    }
    if (color.themeName) {
        var wixColor = siteColors.find(function (c) { return c.reference === color.themeName || c.name === color.themeName; });
        var parsedColor = parseColor(color.value || wixColor.value);
        if (wixColor) {
            return {
                value: parsedColor.rgb().string(),
                name: wixColor.name,
                opacity: parsedColor.valpha,
            };
        }
    }
    var parsedOriginalColor = parseColor(color.value);
    return {
        value: parsedOriginalColor.rgb().string(),
        name: (_a = color.themeName) !== null && _a !== void 0 ? _a : null,
        opacity: parsedOriginalColor.valpha,
    };
}
//# sourceMappingURL=WixStyleColors.js.map